// Heir input model + display labels (bilingual).

export type Madhhab = "hanafi" | "shafii" | "maliki" | "hanbali";

export interface Heirs {
  husband: boolean;
  wives: number;        // 0..4
  sons: number;
  daughters: number;
  father: boolean;
  mother: boolean;
  paternalGrandfather: boolean;   // only counts when no father
  paternalGrandmother: boolean;
  maternalGrandmother: boolean;
  sonsSons: number;     // grandsons via son
  sonsDaughters: number;
  fullBrothers: number;
  fullSisters: number;
  paternalHalfBrothers: number;
  paternalHalfSisters: number;
  maternalHalfSiblings: number;   // combined m/f
}

export const EMPTY_HEIRS: Heirs = {
  husband: false, wives: 0, sons: 0, daughters: 0,
  father: false, mother: false,
  paternalGrandfather: false, paternalGrandmother: false, maternalGrandmother: false,
  sonsSons: 0, sonsDaughters: 0,
  fullBrothers: 0, fullSisters: 0,
  paternalHalfBrothers: 0, paternalHalfSisters: 0,
  maternalHalfSiblings: 0,
};

export type HeirGroup =
  | "husband" | "wives" | "sons" | "daughters"
  | "father" | "mother"
  | "paternalGrandfather" | "paternalGrandmother" | "maternalGrandmother"
  | "sonsSons" | "sonsDaughters"
  | "fullBrothers" | "fullSisters"
  | "paternalHalfBrothers" | "paternalHalfSisters"
  | "maternalHalfSiblings";

export const HEIR_LABELS: Record<HeirGroup, { en: string; bn: string }> = {
  husband: { en: "Husband", bn: "স্বামী" },
  wives: { en: "Wife/Wives", bn: "স্ত্রী" },
  sons: { en: "Son(s)", bn: "পুত্র" },
  daughters: { en: "Daughter(s)", bn: "কন্যা" },
  father: { en: "Father", bn: "পিতা" },
  mother: { en: "Mother", bn: "মাতা" },
  paternalGrandfather: { en: "Paternal grandfather", bn: "দাদা" },
  paternalGrandmother: { en: "Paternal grandmother", bn: "দাদি" },
  maternalGrandmother: { en: "Maternal grandmother", bn: "নানি" },
  sonsSons: { en: "Son's son(s)", bn: "পৌত্র (পুত্রের ছেলে)" },
  sonsDaughters: { en: "Son's daughter(s)", bn: "পৌত্রী (পুত্রের মেয়ে)" },
  fullBrothers: { en: "Full brother(s)", bn: "সহোদর ভাই" },
  fullSisters: { en: "Full sister(s)", bn: "সহোদর বোন" },
  paternalHalfBrothers: { en: "Paternal half-brother(s)", bn: "বৈমাত্রেয় ভাই (পিতার দিক)" },
  paternalHalfSisters: { en: "Paternal half-sister(s)", bn: "বৈমাত্রেয় বোন (পিতার দিক)" },
  maternalHalfSiblings: { en: "Maternal half-sibling(s)", bn: "বৈপিত্রেয় ভাই/বোন (মায়ের দিক)" },
};

export const QURANIC_REFS = {
  childrenSpouse: { ref: "Surah An-Nisa 4:11–12", bn: "সূরা আন-নিসা ৪:১১–১২" },
  kalala: { ref: "Surah An-Nisa 4:176", bn: "সূরা আন-নিসা ৪:১৭৬" },
  maternalHalves: { ref: "Surah An-Nisa 4:12", bn: "সূরা আন-নিসা ৪:১২" },
  asabah: { ref: "Hadith — Sahih al-Bukhari 6732", bn: "হাদিস — সহীহ বুখারী ৬৭৩২" },
};
